module.exports = __webpack_public_path__ + "img/logo-polarize.50b9a791.png";